module.exports = __webpack_public_path__ + "img/MUE-alt.5661a109.svg";